import { Link, useNavigate } from "react-router-dom";
import FormContainer from "../components/common/FormElements/FormContainer";
import FormHeader from "../components/common/FormElements/FormHeader";
import Input from "../components/common/FormElements/Input";
import SubmitButton from "../components/common/FormElements/SubmitButton";
import { useState, ChangeEvent, FormEvent } from "react";

// ** import type
import { ErrorType } from "../types/errorType";
import { RegistrationDataType } from "../types/registrationDataType";
import FormError from "../components/common/FormElements/FormError";

const Registration = () => {
  // navigate variable for navigate to another page
  const navigate = useNavigate();

  // loading state
  const [isLoading, setIsLoading] = useState<boolean>(false);

  // error state
  const [isError, setIsError] = useState<ErrorType>({
    errorType: "",
    errorMessage: "",
  });

  // state for form inputs
  const [data, setData] = useState<RegistrationDataType>({
    fullName: "",
    email: "",
    profession: "",
    password: "",
  });

  // input handler
  const changeHandler = (e: ChangeEvent<HTMLInputElement>) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  // registration form submit handler
  const handleForm = (e: FormEvent<HTMLFormElement>) => {
    // prevent default form submit behavior
    e.preventDefault();

    // set all error property to empty on submit the form
    setIsError({
      errorType: "",
      errorMessage: "",
    });

    // start loading
    setIsLoading(true);

    // if any input field is empty it will give error message under the form or go to the next step
    if (!data.email || !data.fullName || !data.password || !data.profession) {
      setTimeout(() => {
        setIsLoading(false);
        setIsError({
          errorType: "error",
          errorMessage: "Please fill all the field",
        });
      }, 500);
    } else {
      setTimeout(() => {
        setIsLoading(false);
        setIsError({
          errorType: "success",
          errorMessage: "Registration successfull!",
        });
      }, 500);
      setTimeout(() => {
        navigate("/complete-registration");
      }, 1000);
    }
    setData({
      fullName: "",
      email: "",
      profession: "",
      password: "",
    });
  };

  return (
    <FormContainer>
      <FormHeader
        labelText="Registration On Zissanger"
        subheading="Are you new to Zissanger? Fill all the required field to create an account."
      />
      <form
        className="w-full flex flex-col gap-5"
        onSubmit={(e: FormEvent<HTMLFormElement>) => handleForm(e)}
      >
        <Input
          inputType="text"
          placeholder="Your full name"
          icon="fa-solid fa-user"
          inputName="fullName"
          value={data.fullName}
          handler={changeHandler}
        />
        <Input
          inputType="text"
          placeholder="your Profession"
          icon="fa-solid fa-briefcase"
          inputName="profession"
          value={data.profession}
          handler={changeHandler}
        />
        <Input
          inputType="email"
          placeholder="Your email Address"
          icon="fa-solid fa-at"
          inputName="email"
          value={data.email}
          handler={changeHandler}
        />
        <Input
          inputType="password"
          placeholder="Your password"
          icon="fa-solid fa-lock"
          inputName="password"
          value={data.password}
          handler={changeHandler}
        />
        <SubmitButton buttonLabel="Sign Up" isLoading={isLoading} />
        {isError.errorType && <FormError errorObject={isError} />}
      </form>
      <div className="flex justify-center w-full">
        {/* Sign In link */}
        <div className="flex gap-1 items-center">
          <p className="text-slate-500 sm:text-sm md:text-base">
            Already have an account?
          </p>
          <Link
            to="/login"
            className="text-violet-500 w-max sm:text-sm md:text-base"
          >
            Login
          </Link>
        </div>
      </div>
    </FormContainer>
  );
};

export default Registration;
